module.exports = __webpack_public_path__ + "img/20191128170236942.4db91005.jpg";